






































/* General */
import Vue from 'vue'

/* Mixins */

/* Components */

/* Helpers */

/* Data types */

/* API */
import MailboxesAPI from '@/api/modules/mailboxes.api'

export default Vue.extend({
  name: 'MailboxVerificationGmailConfirmationLinkFinder',

  data() {
    return {
      pollingForVerification: true,
      hasConfirmationLink: false,
      poller: null,
      pollCount: 0,
      pollIntervalInMS: 5000,
      pollMax: 12,
      confirmationLink: '',
    }
  },

  computed: {
    mailboxID(): number {
      return Number(this.$route.params.id)
    },
  },

  watch: {
    pollCount: {
      handler(newValue) {
        if (newValue >= this.pollMax) {
          this.endPolling()
        }
      },
    },
  },

  beforeDestroy() {
    this.endPolling()
  },

  async created() {
    this.pollForVerificationEmail()
  },

  methods: {
    endPolling() {
      clearInterval(this.poller)
      this.pollingForVerification = false
    },
    pollForVerificationEmail() {
      this.hasConfirmationLink = false
      this.pollingForVerification = true
      this.pollCount = 0
      this.poller = setInterval(async () => {
        this.pollCount++
        await this.getMostRecentGmailConfirmationLink()
      }, this.pollIntervalInMS)
    },
    async getMostRecentGmailConfirmationLink() {
      try {
        const response = await MailboxesAPI.get_MostRecentGmailConfirmationLink(
          this.mailboxID,
        )
        this.confirmationLink = response.link
        this.hasConfirmationLink = true
        this.endPolling()
      } catch (err) {
        console.log('No confirmation link found.')
      }
    },
  },
})
